
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import styles from './trip.module.css';
import { GridLoader } from 'react-spinners';







import { useNavigate } from 'react-router-dom';
import { API_URL, fetchAndRenderAllData, weatherPageInfo } from '../utils/fatch';

import { Weather } from './weather';
import { useTripInfo } from "../context";

















const EXPENSE_CATEGORIES = [
    { name: 'Food', icon: '🍽️' },
    { name: 'Lodging', icon: '🏨' },
    { name: 'Activities', icon: '🎟️' },
    { name: 'Shopping', icon: '🛍️' },
    { name: 'Transportation', icon: '🚕' },
    { name: 'Other', icon: '📌' },
];

export function MainPage() {



    const {currentTripId ,weatherActive } = useTripInfo();

    const navigate = useNavigate();
    const [selectedCategory, setSelectedCategory] = useState('Food');
    const [StartingBudget, setStartingBudget] = useState(0.00);
    const [expenses, setExpenses] = useState(0.00);
    const [remainingBalance, setRemainingBalance] = useState(0.00);
    const [percentage, setPercentage] = useState(0);
    const [trip_name, setTrip_name] = useState('');
    const [destination, setDestination] = useState('');
    const [addError, setAddError] = useState('');
    const [destinationForWeather, setDestinationForWeather] = useState(true);

    const [image, setImage] = useState('1.jpg');

    const [currentWeather, setCurrentWeather] = useState([]);


    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setRemainingBalance((StartingBudget - expenses).toFixed(2));
        setPercentage(Math.min((expenses / StartingBudget) * 100, 100));
    }, [StartingBudget, expenses])



    useEffect(() => {
        const getDataOnPageLoad = async () => {
            setLoading(true);
            try {
                
            
            const { data, status } = await fetchAndRenderAllData();
            if (status === 401) {
                navigate('/login');
                return
            }
            if (status !== 404) {
                console.log(data);
                const initialBudget = parseFloat(data.currentTripInfo?.budget);
                setStartingBudget(initialBudget);

                const totalExpenses = parseFloat(data.totalExpenses.toFixed(2));

                setExpenses(totalExpenses);

                setTrip_name(data.currentTripInfo.trip_name);
                setDestination(data.currentTripInfo.destination);
                if (data.currentTripInfo.img) {
                    setImage(data.currentTripInfo.img);
                }

            } else {

                navigate('/all_trips');
            }
            } catch (error) {
                console.error(error);
            }



            setLoading(false);
        }


        const getWeatherData = async () => {
            try {
                const result = await weatherPageInfo();
                if (result.status === 200) {

                    const data = result?.data;
                    if (data) {




                        setCurrentWeather(data);
                    }
                } else if (result.status === 400) {
                    setDestinationForWeather(false);
                }






            } catch (error) {
                console.error(error);

            }

        }


        getDataOnPageLoad();

        if (weatherActive.active) {
            getWeatherData();
        }









    }, [weatherActive])




































    const [isVisible, setIsVisible] = useState(false);


    const handleOpenModal = () => setIsVisible(true);





    const handleCloseModal = async (e) => {
        e.preventDefault();
        setIsVisible(false);
        const amountToUpdate = parseFloat(e.target.elements['initial-budget'].value);
        if (isNaN(amountToUpdate) || amountToUpdate < 0) {

            return;
        }
        try {
            const response = await fetch(`${API_URL}/budget`, {
                method: 'POST',
                credentials: 'include', // ✅ Required for cookies
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ amount: amountToUpdate }),
            });
            if (!response.ok) {
                console.error('Error updating budget:', response.statusText);
                return;
            }
            const data = await response.json();

            const initialBudget = parseFloat(data.budget);
            setStartingBudget(initialBudget);


        } catch (error) {
            console.error('Error updating budget:', error);
        }

    };


    async function handleFormSubmit(e) {

        e.preventDefault();

        const expenseData = {
            description: e.target.description.value,
            amount: parseFloat(e.target.amount.value),
            category: e.target.category.value,
        };

        try {
            const response = await fetch(`${API_URL}/expenses`,
                {
                    method: 'POST', // 
                    credentials: 'include', // ✅ Required for cookies
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(expenseData)

                });


            const data = await response.json();

            if (!response.ok) {

                setAddError(data.message || 'Error adding new expense');
                setTimeout(() => {
                    setAddError('');
                }, 10000);
                return;
            }

            console.log(data, expenseData.amount);
            setExpenses((prev) => parseFloat((prev + expenseData.amount).toFixed(2)));
            e.target.reset();

        } catch (error) {
            console.error("Error adding new expense:", error);
        }




    }





    //  console.log(props);



    return (<>




        {/*  <Header trip_name={trip_name} loading={loading} /> */}
        <div className={styles.headersAndContent}>
            <div className={styles.headers}>


                {/*  <Header trip_name={trip_name} loading={loading} /> */}
                {/*  <!-- UPDATED: The background image is now on the header itself --> */}

                {!loading && <>
                


                    <header className={`${styles.headerWithImage} text-center`} style={{ backgroundImage: `url(${image})` }}>
                        <div className={styles.headerActions} style={{paddingTop: '10px'}}>
                            <Link to={`/share_trip/${currentTripId}`} className={styles.inviteTripLink} title="Invite people to this trip">
                                <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px"><path d="M720-400v-120H600v-80h120v-120h80v120h120v80H800v120h-80Zm-360-80q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Z" /></svg>
                                <span>Invite</span>
                            </Link>

                            <Link to={`/update_trip/${currentTripId}`} className={styles.updateTripLink}>

                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z" /></svg>
                        </Link>

                        </div>
                        

                        <div className="relative z-10">
                            {/*    <!-- Updated header text and added script font class --> */}
                            <h1 className={`${styles.goldenText} ${styles.scriptFontHeader}`}>
                                <span>{trip_name} to</span>
                                <span className={styles.largeTownText}>{destination}</span>
                            </h1>
                            <p className="text-gray-200 mt-2 text-lg">Keep track of your spending with ease.</p>
                        </div>

                    </header>



                    {!weatherActive.endAlready && <>
                        <Weather currentWeather={currentWeather} destinationForWeather={destinationForWeather} />

                    </>}



                </>}
            </div>
            {loading && <div className={styles.loadingIndicator}><GridLoader color="#d4ebfb" size={25} /></div>}
            {!loading && <>






                <div className={styles.content}>



                    {/*  <!-- Main Navigation Links --> */}
                    <nav className={`flex justify-center space-x-4 mb-8 text-lg font-medium ${styles.activitiesExpensesButtons}`}>
                        <Link to="/Suggestions" className={`bg-gray-50 p-6 rounded-xl shadow-md ${styles.activitiesExpensesLink}`}>

                            <h2 className={`text-2xl font-bold text-gray-800 mb-4 flex items-center`} >
                                <div className={styles.svgCon}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="30px" fill="#f93928ff"

                                    >
                                        <path d="M80-120v-80h160v-160h-80v-80h84q12-75 66.5-129.5T440-636v-204h280v160H520v44q75 12 129.5 66.5T716-440h84v80h-80v160h160v80H80Zm240-80h120v-160H320v160Zm200 0h120v-160H520v160Z" />
                                    </svg>
                                </div>
                                <span className="text-2xl font-bold">Suggested Activities</span>
                            </h2>
                        </Link>
                        <Link to="/my_expenses" className={`bg-gray-50 p-6 rounded-xl shadow-md ${styles.activitiesExpensesLink}`}>

                            <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                                <div className={styles.svgCon}>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="30px" fill="#82ff5bff"><path d="M240-80q-50 0-85-35t-35-85v-120h120v-560l60 60 60-60 60 60 60-60 60 60 60-60 60 60 60-60 60 60 60-60v680q0 50-35 85t-85 35H240Zm480-80q17 0 28.5-11.5T760-200v-560H320v440h360v120q0 17 11.5 28.5T720-160ZM360-600v-80h240v80H360Zm0 120v-80h240v80H360Zm320-120q-17 0-28.5-11.5T640-640q0-17 11.5-28.5T680-680q17 0 28.5 11.5T720-640q0 17-11.5 28.5T680-600Zm0 120q-17 0-28.5-11.5T640-520q0-17 11.5-28.5T680-560q17 0 28.5 11.5T720-520q0 17-11.5 28.5T680-480Z" /></svg>
                                </div>
                                <span className="text-2xl font-bold">View Expenses</span>
                            </h2>
                        </Link>
                    </nav>

                    {/* <!-- Trip Tools Link Card --> */}
                    <Link to="/trip-tools" className={styles.tripToolsCard}>
                        <div className={styles.tripToolsCardBg}></div>
                        <div className={styles.tripToolsCardContent}>
                            <div className={styles.tripToolsCardIcons}>
                                <span>🎒</span>
                                <span>💱</span>
                                <span>🏛️</span>
                                <span>🗣️</span>
                                <span>📄</span>
                                <span>🚨</span>
                            </div>
                            <div className={styles.tripToolsCardText}>
                                <h2>Trip Toolkit</h2>
                                <p>Packing list, currency, phrases & more</p>
                            </div>
                            <div className={styles.tripToolsCardArrow}>
                                <span className="material-symbols-outlined">arrow_forward</span>
                            </div>
                        </div>
                    </Link>



                    {/*  <!-- Budget Summary Section --> */}
                    <section className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
                        <div className="bg-blue-50 p-6 rounded-xl text-center flex flex-col justify-between items-center relative">
                            <h2 className="text-xl font-medium text-blue-700">{/* Starting */}Total Budget</h2>
                            <p id="total-budget" className="text-3xl font-bold mt-2 text-blue-800">${StartingBudget}</p>
                            {/*  <button id="edit-budget-btn" className="absolute top-2 right-2 text-blue-400 hover:text-blue-600 transition-colors">
                    <i className="fas fa-bars text-lg"></i>
                </button> */}
                            <button id="edit-budget-btn" onClick={handleOpenModal} className="text-blue-400 hover:text-blue-600 mt-2 text-sm"><i className="fa-solid fa-pen-to-square mr-1"></i> Edit Budget</button>
                        </div>
                        <div className="bg-orange-50 p-6 rounded-xl text-center">
                            <h2 className="text-xl font-medium text-orange-700">Total Spent</h2>
                            <p id="total-spent" className="text-3xl font-bold mt-2 text-orange-800">${expenses}</p>
                        </div>
                        <div className="bg-emerald-50 p-6 rounded-xl text-center">
                            <h2 className="text-xl font-medium text-emerald-700">Remaining Balance</h2>
                            <p id="remaining-balance" className="text-3xl font-bold mt-2 text-emerald-800">${remainingBalance}</p>
                        </div>
                    </section>

                    {/*     <!-- Budget Progress Bar --> */}
                    <section className="mb-10">
                        <div className="bg-gray-200 rounded-full h-4 relative overflow-hidden">
                            <div id="budget-bar" className={`h-full ${percentage >= 100 ? 'bg-red-500' : 'bg-teal-500'} rounded-full transition-all duration-500 ease-out`} style={{ width: `${percentage}%` }}></div>
                        </div>
                    </section>

                    {/*  <!-- Expense Form Section --> */}
                    <section className="mb-10" id='newExp'>
                        <form id="expense-form" className={styles.expenseCard} onSubmit={handleFormSubmit}>
                            <h2 className={styles.expenseCardTitle}>Add an expense</h2>

                            {/* Amount leads - it is what people reach for first */}
                            <div className={styles.amountField}>
                                <span className={styles.amountCurrency}>$</span>
                                <input
                                    type="number"
                                    id="amount"
                                    name="amount"
                                    step="0.01"
                                    min="0"
                                    inputMode="decimal"
                                    placeholder="0.00"
                                    className={styles.amountInput}
                                />
                            </div>

                            <input
                                type="text"
                                id="description"
                                name="description"
                                required
                                placeholder="What was it for?"
                                className={styles.descriptionInput}
                            />

                            {/* Chips beat a native select on a phone - one tap, no popup */}
                            <span className={styles.categoryLabel}>Category</span>
                            <div className={styles.categoryChips}>
                                {EXPENSE_CATEGORIES.map(({ name, icon }) => (
                                    <button
                                        type="button"
                                        key={name}
                                        className={`${styles.categoryChip} ${selectedCategory === name ? styles.categoryChipActive : ''}`}
                                        onClick={() => setSelectedCategory(name)}
                                    >
                                        <span aria-hidden="true">{icon}</span>
                                        {name}
                                    </button>
                                ))}
                            </div>
                            <input type="hidden" id="category" name="category" value={selectedCategory} readOnly />

                            {addError && <p className={styles.expenseError}>{addError}</p>}

                            <button type="submit" id="submit-btn" className={styles.expenseSubmit}>
                                Add expense
                            </button>
                        </form>
                    </section>

                </div> </>}

        </div>



        {/*  <!-- The Budget Edit Modal --> */}
        <div id="budget-modal" className={`${styles.modalOverlay} ${isVisible ? styles.visible : ''}`}>
            <form className={styles.modalContent} onSubmit={handleCloseModal}>
                <h3 className="text-2xl font-bold text-gray-800 mb-4">Set Your Total Budget</h3>
                <div className={styles.inputGroup}>
                    <input type="number" id="initial-budget-input" name="initial-budget" required step="1" min="0" placeholder=" "
                        className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-all" />
                    <label htmlFor="initial-budget-input">Starting Budget ($)</label>
                </div>
                <br />
                <button type='submit' className={`${styles.fancyButton} w-full px-6 py-3 bg-teal-600 text-white font-bold rounded-lg hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2`}>
                    Done
                </button>
            </form>
        </div>

        {/*  <script src="./app.js"></script> */}



    </>)
}




